import { ProductsResponseOut } from '../../store/api';
import { mapProductOutToProductMetaDataArray } from '../ProductOutMappings';
import { FetchProductsFromCatalogueResponse } from '../productList/fetchProductsFromCatalogue';
import { shopPrefix } from '../../config';
import { http } from '../axios';
import { Pagination } from '../../../models/Pagination';

export interface LanguageParams {
    loanFormat: string | null;
    filterMap?: string;
    language?: string;
    pagination: Pagination;
    ageCategory: string | null;
    isLanguageLearningScope: boolean;
}

export const fetchLanguageProducts = ({
    loanFormat,
    filterMap,
    language,
    pagination,
    ageCategory,
    isLanguageLearningScope
}: LanguageParams): Promise<FetchProductsFromCatalogueResponse> => {
    const url = isLanguageLearningScope
        ? `${shopPrefix}/v1/languagelearning/allproducts/products`
        : `${shopPrefix}/v1/lote/allproducts/products`;

    return http
        .post<ProductsResponseOut>(url, filterMap, {
            params: {
                ...pagination,
                ageCategory,
                language,
                loanFormat: loanFormat ? loanFormat.toUpperCase() : undefined
            },
            requestGroup: [
                loanFormat,
                JSON.stringify(filterMap),
                pagination.page,
                pagination.pageSize,
                pagination.sortBy,
                ageCategory
            ].join('-')
        })
        .then(response => ({
            total: response.data.totalHits ?? 0,
            products: mapProductOutToProductMetaDataArray(response.data.hits)
        }));
};
